var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobEyeClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833336 8.00001C0.833336 8.00001 4.32334 3.00001 10 3.00001C10.7892 3.00001 11.5333 3.10001 12.2317 3.26834L6.96667 8.53334C6.77006 8.10449 6.66775 7.63844 6.66667 7.16667C6.66667 6.38584 6.94584 5.67751 7.39584 5.10834C5.4025 5.78667 3.88334 7.09751 3.01667 8.00001C3.75572 8.76943 4.59029 9.44101 5.5 9.99834L4.29167 11.2083C2.08167 9.77501 0.833336 8.00001 0.833336 8.00001ZM19.1667 8.00001C19.1667 8.00001 15.6767 13 10 13C9.21167 13 8.47 12.8967 7.77 12.7308L4.16667 16.3333L2.91667 15.0833L17.0833 0.916672L18.3333 2.16667L15.7108 4.78917C17.9167 6.22501 19.1667 8.00001 19.1667 8.00001ZM16.9875 8.005C16.2479 7.23262 15.4112 6.5595 14.4983 6.00251L13.3333 7.16667C13.3333 9.00834 11.8417 10.5 10 10.5L9.21084 11.2892C9.46917 11.3142 9.73083 11.3333 10 11.3333C13.315 11.3333 15.7858 9.26834 16.9875 8.005Z",
    fill: "#457B9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobEyeClose);
export default __webpack_public_path__ + "static/media/mob_eye_close.b2c83e5e34353b82aaede48fb0ea92f6.svg";
export { ForwardRef as ReactComponent };